// @ts-nocheck
// this file was patched by @terra

import { z } from 'zod';
import { NetblockSourceTypeSchema } from '../inputTypeSchemas/NetblockSourceTypeSchema'

/////////////////////////////////////////
// NETBLOCK EVIDENCE SCHEMA
/////////////////////////////////////////

export const NetblockEvidenceSchema = z.object({
  evidenceType: NetblockSourceTypeSchema,
  text: z.string(),
  timestamp: z.coerce.date().nullable(),
})

export type NetblockEvidence = z.infer<typeof NetblockEvidenceSchema>

export default NetblockEvidenceSchema;
